import React, {Component, Fragment} from 'react';
import {Redirect} from "react-router";
import {Trans, withTranslation} from 'react-i18next';
import Header from "../Parts/Header";
import SubHeader from "../Parts/SubHeader";
import MSign from "../Sign/MSign";
import SmartId from "../Sign/SmartId";
import {toast} from "react-toastify";
import BankSign from "../Sign/Banksign";
import Loading from "../Parts/Loading";
import EmbeddedPdf from "../Parts/EmbeddedPdf";
import Ondato from "../Ondato";

class DocumentPreview extends Component {
    constructor(props) {
        super(props);

        const {match: {params}} = this.props;

        this.state = {
            data: {},
            token: params.token,
            sub_step: 'documentPreview',
            step_count: 2,
            current_step: 1,
            redirectToNextStep: false,
            loading: true,
            file_id: null,
            bankLinkUrls: [],
            isNextStepPossible: true,

            application_token: null,
            show_ondato: true,
            ondato_identification_id: null
        };

        this.signButtonRef = React.createRef();
        this.state.pdf_url = this.getDocumentUrl();

        this.chooseDocumentSignMethod = this.chooseDocumentSignMethod.bind(this);
        this.callbackAfterSign = this.callbackAfterSign.bind(this);
        this.scrollToSignButton = this.scrollToSignButton.bind(this);
        this.getDocumentPdf = this.getDocumentPdf.bind(this);
        this.getDocumentUrl = this.getDocumentUrl.bind(this);
        this.isOndatoNeeded = this.isOndatoNeeded.bind(this);

        this.getDocumentPdf();
    }

    scrollToSignButton() {
        this.signButtonRef.current.scrollIntoView({behavior: "smooth"});
    }

    getDocumentUrl() {
        return '/api/remote_sign/' + this.state.token + '/display_pdf';
    }

    getDocumentPdf() {
        // Load into cache
        axios.get('/api/remote_sign/' + this.state.token + '/get_pdf')
            .then(
                data => {
                    this.isOndatoNeeded();
                },
                error => {
                    toast.error("Nepavyko sugeneruoti sutikimo dokumento");
                    this.setState({isNextStepPossible: false, loading: false});
                }
            );
    }

    isOndatoNeeded() {
        // Load into cache
        axios.get('/api/remote_sign/' + this.state.token + '/is_ondato_needed')
            .then(
                data => {
                    this.setState({
                        show_ondato: data.data.ondato_needed,
                        application_token: data.data.appl_token,
                        ondato_identification_id: data.data.ondato_identification_id,
                        loading: false,
                    });

                    const {match: {params}} = this.props;
                    if (params.substep === 'returning_from_ondato') {
                        this.chooseDocumentSignMethod();
                    }
                }
            );
    }

    // SmartID and Msign only
    callbackAfterSign() {
        this.setState({redirectToNextStep: true});
    }

    chooseDocumentSignMethod() {
        if (this.state.isNextStepPossible === true) {
            this.setState({isNextStepPossible: false});
        }

        this.setState({loading: true});

        axios.get('/api/remote_sign/' + this.state.token + '/get_sign_info')
            .then(
                data => {
                    if (data.data.status === 'success') {
                        this.setState({
                            sub_step: 'chooseDocumentSignMethod',
                            current_step: 2,
                            file_id: data.data.data.file_id,
                            bankLinkUrls: data.data.data.links,
                            loading: false,
                        });
                    }
                }
            );
    }

    render() {
        if (this.state.redirectToNextStep) {
            return <Redirect push={true} to={'/waiting_document/' + this.state.token + '/done'}/>
        }

        return (
            <div>
                <Header title={this.props.t('step.remote_sign_document')}/>

                <div className="section window-layout">
                    <div className="container frame">
                        <SubHeader title={this.props.t('substep.' + this.state.sub_step)}
                                   step_count={this.state.step_count}
                                   current_step={this.state.current_step}/>
                        <div className="row">
                            {this.state.loading ?
                                <div className="tab-content frame p-4 p-sm-5 w-100" id="authTabContent">
                                    <div aria-labelledby="private-tab" className="tab-pane fade show active"
                                         id="private" role="tabpanel">
                                        <Loading/>
                                    </div>
                                </div>
                                :
                                <Fragment>
                                    {this.state.sub_step === 'documentPreview' ?
                                        <Fragment>
                                            <div className="col-12 mt-4">
                                                <div className="embed-document">
                                                    <EmbeddedPdf src={this.state.pdf_url}/>
                                                </div>
                                            </div>

                                            <div
                                                className="form-group col-12 d-flex flex-column align-items-center mt-3"
                                                ref={this.signButtonRef}
                                            >
                                                <button className="btn btn-primary btn-lg"
                                                        onClick={this.chooseDocumentSignMethod}
                                                        id="btn-show-consent-sign-options"
                                                        disabled={!this.state.isNextStepPossible}
                                                >{this.props.t('forms.sign_document')}</button>
                                            </div>
                                        </Fragment> : ''}

                                    {this.state.sub_step === 'chooseDocumentSignMethod' ?
                                        <Fragment>
                                            <div className="tab-content frame p-4 p-sm-5 w-100" id="authTabContent">
                                                <div aria-labelledby="private-tab" className="tab-pane fade show active"
                                                     id="private" role="tabpanel">
                                                    <ul className="nav nav-tabs bg-gray-cloud justify-content-center"
                                                        id="authDeviceTab" role="tablist">
                                                        <li className="nav-item">
                                                            <a aria-controls="auth-id-bank" aria-selected="true"
                                                               className="nav-link"
                                                               data-toggle="tab" href="#auth-id-bank"
                                                               id="auth-id-bank-tab"
                                                               role="tab">
                                                                <i className="icons icon-building"></i> {this.props.t('forms.sign_by_1_ct')}
                                                            </a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a aria-controls="auth-mobile-id" aria-selected="false"
                                                               className="nav-link"
                                                               data-toggle="tab" href="#auth-mobile-id"
                                                               id="auth-mobile-id-tab" role="tab">
                                                                <i className="icons icon-phone"></i> {this.props.t('forms.sign_by_esign')}
                                                            </a>
                                                        </li>
                                                        <li className="nav-item">
                                                            <a aria-controls="auth-smart-id" aria-selected="false"
                                                               className="nav-link active"
                                                               data-toggle="tab" href="#auth-smart-id"
                                                               id="auth-smart-id-tab" role="tab">
                                                                <i className="icon-smartid"></i> {this.props.t('forms.sign_by_smart_id')}
                                                            </a>
                                                        </li>
                                                    </ul>

                                                    <div className="tab-content border py-3"
                                                         id="authDeviceTabContent">
                                                        <div aria-labelledby="auth-id-bank-tab"
                                                             className="tab-pane fade" id="auth-id-bank"
                                                             role="tabpanel">
                                                            {this.state.show_ondato ?
                                                                <div className="p-4">
                                                                    <Ondato
                                                                        application_token={this.state.application_token}
                                                                        successCallback={() => {
                                                                            this.setState({show_ondato: false})
                                                                        }}
                                                                        ondato_identification_id={this.state.ondato_identification_id}
                                                                        file_token={this.state.token}
                                                                        remote_sign={true}
                                                                    />
                                                                </div>
                                                                :
                                                                <div className="container py-4">
                                                                    <div
                                                                        className="row bank-links d-flex justify-content-center">
                                                                        <div className="col-12 col-md-8">
                                                                            <div className="container">
                                                                                <BankSign
                                                                                    bankLinkUrls={this.state.bankLinkUrls}/>
                                                                            </div>
                                                                            <div className="container mt-3">
                                                                                <div className="row">
                                                                                    <div className="col-12 text-center">
                                                                                        <Trans
                                                                                            i18nKey="forms.have_questions">
                                                                                            Turite klausimų? Skambinkite
                                                                                            mums <a
                                                                                            href="tel:+37070070080">+370
                                                                                            700 700 80</a> ir mes Jums
                                                                                            padėsime atlikti dokumento
                                                                                            pasirašymą
                                                                                        </Trans>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>

                                                        <div aria-labelledby="auth-mobile-id"
                                                             className="tab-pane fade"
                                                             id="auth-mobile-id"
                                                             role="tabpanel">
                                                            <div className="container py-5 p-lg-5">
                                                                <div className="row justify-content-md-center">
                                                                    <MSign file_id={this.state.file_id}
                                                                           file_token={this.state.token}
                                                                           callback={this.callbackAfterSign}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div aria-labelledby="auth-smart-id"
                                                             className="tab-pane fade active show"
                                                             id="auth-smart-id"
                                                             role="tabpanel">
                                                            <div className="container py-5 p-lg-5">
                                                                <div className="row justify-content-md-center">
                                                                    <SmartId file_id={this.state.file_id}
                                                                             file_token={this.state.token}
                                                                             callback={this.callbackAfterSign}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Fragment> : ''}
                                </Fragment>
                            }
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation()(DocumentPreview);
